export default {
    displayValue(value: any): string {
        return String(value);
    },

    valueOf(value: any) {
        return value;
    },
};
